window.__GROMOV_UI_LOADED = true;
/* Disable scroll-reveal animation on article pages */
(function() {
  if (document.body.classList.contains('template-article')) {
    document.querySelectorAll('.shopify-section').forEach(function(s) {
      s.classList.add('shopify-section--reveal');
      s.classList.add('shopify-section--no-animation');
    });
  }
})();

/* ============================================
 * Floating WhatsApp button — injected via JS to bypass theme output filtering.
 * ============================================ */
(function(){
  'use strict';
  function injectWA(){
    if (document.querySelector('.gromov-wa-btn-js')) return;
    var num = '971' + '58593' + '5597';
    var a = document.createElement('a');
    a.className = 'gr-wa gromov-wa-btn-js';
    a.href = 'https://wa.me/' + num;
    a.target = '_blank';
    a.rel = 'noopener noreferrer nofollow';
    a.setAttribute('aria-label', 'Contact GROMOV on WhatsApp');
    a.style.cssText = 'position:fixed;bottom:24px;right:24px;z-index:9999;width:52px;height:52px;border-radius:50%;background:#25D366;box-shadow:0 4px 16px rgba(0,0,0,0.25);display:flex;align-items:center;justify-content:center;text-decoration:none;transition:transform 0.2s,box-shadow 0.2s;';
    a.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="width:32px;height:32px;fill:#fff;"><path d="M12.031 0C5.385 0 0 5.385 0 12.031c0 2.128.556 4.195 1.611 6.012L.452 24l6.136-1.611A11.968 11.968 0 0012.031 24c6.645 0 12.03-5.385 12.03-12.031C24.062 5.385 18.676 0 12.031 0zm0 22.015c-1.802 0-3.565-.486-5.111-1.405l-.367-.218-3.792.995.996-3.792-.218-.367A10.04 10.04 0 011.986 12.03c0-5.541 4.504-10.045 10.045-10.045 5.541 0 10.044 4.504 10.044 10.045 0 5.541-4.503 10.045-10.044 10.045zm5.516-7.531c-.302-.152-1.787-.883-2.064-.984-.277-.101-.478-.152-.68.152-.201.303-.78 1.008-.957 1.21-.176.202-.353.228-.655.076-.302-.152-1.275-.469-2.428-1.516-.897-.814-1.503-1.821-1.68-2.124-.176-.303-.019-.467.132-.619.136-.136.302-.353.453-.53.151-.176.201-.302.302-.504.101-.202.05-.378-.025-.53-.075-.152-.68-1.637-.93-2.243-.245-.591-.496-.51-.68-.52-.176-.01-.378-.01-.58-.01s-.53.076-.807.404c-.277.328-1.058 1.034-1.058 2.52 0 1.488 1.084 2.924 1.235 3.126.151.202 2.14 3.268 5.184 4.58.724.312 1.288.498 1.727.638.728.231 1.391.198 1.916.12.589-.088 1.787-.73 2.039-1.436.252-.706.252-1.312.176-1.436-.076-.124-.277-.2-.58-.352z"/></svg>';
    a.addEventListener('mouseenter', function(){ this.style.transform='scale(1.08)'; this.style.boxShadow='0 6px 22px rgba(0,0,0,0.35)';});
    a.addEventListener('mouseleave', function(){ this.style.transform=''; this.style.boxShadow='0 4px 16px rgba(0,0,0,0.25)';});
    document.body.appendChild(a);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectWA);
  } else {
    injectWA();
  }
})();

/* ============================================
 * Obfuscated WhatsApp link hydration (inline anchors on pages/products).
 * Static HTML contains <a class="gr-wa" data-p1 data-p2 data-p3 href="#wa">.
 * ============================================ */
(function() {
  'use strict';
  function hydrate() {
    var links = document.querySelectorAll('a.gr-wa[data-p1][data-p2][data-p3]');
    if (!links.length) return;
    links.forEach(function(a) {
      var num = (a.dataset.p1 || '') + (a.dataset.p2 || '') + (a.dataset.p3 || '');
      if (!num || num.length < 10) return;
      a.href = 'https://wa.me/' + num;
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener noreferrer nofollow');
      var display = '+' + num.slice(0, 3) + ' ' + num.slice(3, 5) + ' ' + num.slice(5, 8) + ' ' + num.slice(8);
      if (a.dataset.waShow === 'number') {
        a.textContent = display;
      } else if (a.querySelector('[data-wa-display]')) {
        a.querySelectorAll('[data-wa-display]').forEach(function(el) {
          el.textContent = display;
        });
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }
})();

window.__GROMOV_UI_DONE = true;
